const TenantModulesEnum = Object.freeze({
    SYSTEM_MANAGEMENT: 'SystemManagement',
    TO_MANAGEMENT: 'ToManagement',
    REVENUE: 'Revenue',
    OWNERS_PORTAL: 'OwnersPortal',
    COLLECTIONS: 'Collections',
})

const tenantModuleApiNameMap = Object.freeze({
    [TenantModulesEnum.SYSTEM_MANAGEMENT]: 'system_management',
    [TenantModulesEnum.TO_MANAGEMENT]: 'to_management',
    [TenantModulesEnum.REVENUE]: 'revenue',
    [TenantModulesEnum.OWNERS_PORTAL]: 'owners_portal',
    [TenantModulesEnum.COLLECTIONS]: 'collections',
})

/**
 * Maps the UI module identifier to the API slug expected by userGetSessionForModule.
 * Falls back to lowercasing the provided value to avoid hard failures if a new module is added.
 */
export const getTenantModuleApiName = module =>
    tenantModuleApiNameMap[module] ?? module?.toLowerCase?.() ?? ''

export default TenantModulesEnum